/* Ridgebrace: mobiel menu. Paneel opent onder de header en loopt door tot onder de Safari-balk. */
(() => {
  const btn = document.querySelector('[data-rb-menu-open]');
  const menu = document.querySelector('[data-rb-menu]');
  const header = document.querySelector('[data-rb-header]');
  if (!btn || !menu || !header) return;

  const setTop = () => {
    const bottom = Math.max(0, header.getBoundingClientRect().bottom);
    menu.style.setProperty('--rb-menu-top', bottom + 'px');
  };
  const open = (viaKeyboard) => {
    setTop();
    menu.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    btn.querySelector('.rb-visually-hidden').textContent = 'Close menu';
    header.classList.add('rb-header--menu');
    // Alleen bij het toetsenbord de focus naar de eerste link, anders toont iOS een witte focusrand om "Shop the sleeve" (Enes chat 19).
    if (viaKeyboard) menu.querySelector('a')?.focus({ preventScroll: true });
  };
  // Sluiten met een korte fade (chat 19, Enes: menu niet smooth). Bij reduced motion meteen dicht.
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const close = (focusBtn) => {
    if (reduce.matches) menu.hidden = true;
    else {
      menu.classList.add('rb-menu--closing');
      setTimeout(() => { menu.hidden = true; menu.classList.remove('rb-menu--closing'); }, 180);
    }
    btn.setAttribute('aria-expanded', 'false');
    btn.querySelector('.rb-visually-hidden').textContent = 'Menu';
    header.classList.remove('rb-header--menu');
    if (focusBtn) btn.focus();
  };

  btn.addEventListener('click', (e) => (menu.hidden ? open(e.detail === 0) : close(false)));
  menu.addEventListener('click', (e) => { if (e.target.closest('a')) close(false); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !menu.hidden) close(true); });
  window.addEventListener('resize', () => { if (!menu.hidden) setTop(); });
})();

/* Balk: 1 boodschap tegelijk, wisselt rustig, pauzeert bij hover en focus. */
(() => {
  const bar = document.querySelector('[data-rb-announce]');
  if (!bar) return;
  const items = [...bar.querySelectorAll('.rb-announce__item')];
  if (items.length < 2) return;
  let i = 0, paused = false;
  const ms = (parseInt(bar.dataset.interval, 10) || 5) * 1000;
  bar.addEventListener('mouseenter', () => (paused = true));
  bar.addEventListener('mouseleave', () => (paused = false));
  bar.addEventListener('focusin', () => (paused = true));
  bar.addEventListener('focusout', () => (paused = false));
  setInterval(() => {
    if (paused || document.hidden) return;
    items[i].hidden = true;
    i = (i + 1) % items.length;
    items[i].hidden = false;
  }, ms);
})();

/* Header loopt mee: na het scrollen krijgt de doorzichtige header een vaste kleur. */
(() => {
  const header = document.querySelector('[data-rb-header]');
  if (!header) return;
  const sentinel = document.createElement('div');
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:80px;pointer-events:none;';
  const main = document.querySelector('#MainContent') || document.body;
  main.style.position = main.style.position || 'relative';
  main.prepend(sentinel);
  new IntersectionObserver(([e]) => header.classList.toggle('rb-header--scrolled', !e.isIntersecting)).observe(sentinel);
})();

/* Nieuwsbrief-popup: 1 keer voor nieuwe bezoekers, daarna nooit meer op dit apparaat. */
(() => {
  const dlg = document.querySelector('[data-rb-popup]');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  const KEY = 'rb-popup-seen';
  const seen = () => { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return true; } };
  const mark = () => { try { localStorage.setItem(KEY, '1'); } catch (e) {} };
  const open = (viaKeyboard) => { if (!dlg.open) { dlg.showModal(); mark(); } };
  dlg.addEventListener('click', (e) => {
    if (e.target.closest('[data-rb-popup-close]') || e.target === dlg) dlg.close();
  });
  document.querySelectorAll('[data-rb-popup-open]').forEach((b) => b.addEventListener('click', open));
  if (dlg.querySelector('[data-rb-popup-success]')) { open(); return; }
  if (seen() || window.Shopify?.designMode) return;
  setTimeout(open, (parseInt(dlg.dataset.delay, 10) || 8) * 1000);
})();

/* Hoogte van de balk doorgeven, zodat de header precies bovenaan plakt als de balk weg is. */
(() => {
  const bar = document.querySelector('[data-rb-announce]');
  const group = document.getElementById('header-group');
  if (!bar || !group) return;
  const set = () => group.style.setProperty('--rb-bar-h', bar.offsetHeight + 'px');
  set();
  new ResizeObserver(set).observe(bar);
})();

/* What's in the sleeve: lijntje van elk onderdeel naar het stuk op de foto (alleen naast elkaar, vanaf 1100 px). */
document.querySelectorAll('[data-rb-inside]').forEach((sec) => {
  const grid = sec.querySelector('.rb-inside__grid');
  const photo = sec.querySelector('[data-rb-inside-photo]');
  const svg = sec.querySelector('[data-rb-inside-lines]');
  const parts = [...sec.querySelectorAll('[data-rb-part]')];
  if (!grid || !photo || !svg || !parts.length) return;
  const NS = 'http://www.w3.org/2000/svg';
  const draw = () => {
    svg.replaceChildren();
    if (window.innerWidth < 1100) return;
    const g = grid.getBoundingClientRect(), ph = photo.getBoundingClientRect();
    svg.setAttribute('viewBox', `0 0 ${g.width} ${g.height}`);
    parts.forEach((part) => {
      const name = part.querySelector('.rb-inside__name').getBoundingClientRect();
      const left = name.left < ph.left;
      const x1 = (left ? name.right + 16 : name.left - 16) - g.left, y1 = name.top + name.height / 2 - g.top;
      const x2 = ph.left - g.left + ph.width * (Number(part.dataset.x) / 100), y2 = ph.top - g.top + ph.height * (Number(part.dataset.y) / 100);
      const edge = (left ? ph.left + 8 : ph.right - 8) - g.left;
      const line = document.createElementNS(NS, 'polyline');
      line.setAttribute('points', `${x1},${y1} ${edge},${y1} ${x2},${y2}`);
      const dot = document.createElementNS(NS, 'circle');
      dot.setAttribute('cx', x2); dot.setAttribute('cy', y2); dot.setAttribute('r', 4);
      svg.append(line, dot);
    });
  };
  draw();
  window.addEventListener('resize', draw);
  window.addEventListener('load', draw);
  photo.querySelector('img')?.addEventListener('load', draw);
});

/* Blokken schuiven zacht omhoog in beeld. Alleen wat onder de vouw staat, nooit bij reduced motion. Zonder JS is alles gewoon zichtbaar. */
(() => {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode) return;
  // Alleen de inhoud (.rb-wrap) beweegt, de gekleurde achtergrond en de bergkam staan stil (Enes chat 18).
  const els = [...document.querySelectorAll('#MainContent .rb-section')]
    .map((sec) => sec.querySelector('.rb-wrap'))
    .filter((el) => el && el.getBoundingClientRect().top > window.innerHeight * 0.9);
  const io = new IntersectionObserver((entries) => entries.forEach((e) => {
    if (!e.isIntersecting) return;
    e.target.classList.add('is-in');
    io.unobserve(e.target);
  }), { rootMargin: '0px 0px -8% 0px' });
  els.forEach((el) => { el.classList.add('rb-reveal'); io.observe(el); });
})();

/* Klik op een link naar de pagina waar je al bent (logo op de home): naar boven scrollen in plaats van herladen.
   Horizon zet op desktop anders de oude scrollpositie terug uit history.state (scroll-container.js), Enes chat 19. */
document.addEventListener('click', (e) => {
  const a = e.target.closest('a[href]');
  if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank') return;
  const url = new URL(a.href, location.href);
  if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || url.hash) return;
  e.preventDefault();
  const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const wrap = window.matchMedia('(min-width: 990px)').matches ? document.querySelector('.page-wrapper') : null;
  (wrap || window).scrollTo({ top: 0, behavior });
});

/* Winkelwagen: aantal aanpassen werkt het subtotaal meteen bij (Enes chat 19). Het formulier wordt zelf verstuurd,
   zodat Shopify ook de automatische korting (The Trail Set) opnieuw rekent. De knop Update blijft als terugval zonder JS. */
(() => {
  const form = document.querySelector('.rb-cartpage__grid');
  if (!form) return;
  const btn = form.querySelector('button[name="update"]');
  let timer;
  const send = () => { clearTimeout(timer); timer = setTimeout(() => (btn ? form.requestSubmit(btn) : form.submit()), 450); };
  form.querySelectorAll('input[name="updates[]"]').forEach((i) => {
    i.addEventListener('input', () => { if (i.value !== '') send(); });
    i.addEventListener('change', send);
  });
})();

/* Nieuwsbrief: elke aanmelding (blok, popup, footer) gaat ook naar Kit-formulier 10087883, zodat Kit de welkomstmail
   met TRAIL10 stuurt (chat 29, akkoord Enes). Het Shopify-formulier wordt daarna gewoon verstuurd. */
document.addEventListener('submit', (e) => {
  const form = e.target;
  const tags = form.querySelector('input[name="contact[tags]"]');
  const email = form.querySelector('input[name="contact[email]"]');
  if (!tags || !email || !/newsletter/.test(tags.value) || !email.value) return;
  // Shopify's hCaptcha verstuurt het formulier na de check opnieuw, dus maar 1 keer per adres naar Kit.
  if (form.dataset.rbKit === email.value) return;
  form.dataset.rbKit = email.value;
  try {
    fetch('https://app.kit.com/forms/10087883/subscriptions', {
      method: 'POST',
      mode: 'no-cors',
      keepalive: true,
      body: new URLSearchParams({ email_address: email.value.trim() }),
    });
  } catch (err) {}
});

/* Aftellen in de balk (data-rb-ends, UTC). Na afloop verdwijnt de boodschap, het einde is echt (geen herstart). */
(() => {
  document.querySelectorAll('[data-rb-ends]').forEach((item) => {
    const end = Date.parse(item.dataset.rbEnds);
    const out = item.querySelector('[data-rb-timer]');
    if (!end || !out) return;
    const tick = () => {
      const left = end - Date.now();
      if (left <= 0) { item.remove(); clearInterval(id); return; }
      const d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, m = Math.floor(left / 6e4) % 60, s = Math.floor(left / 1e3) % 60;
      out.textContent = 'Ends in ' + (d ? d + 'd ' : '') + h + 'h ' + String(m).padStart(2, '0') + 'm ' + String(s).padStart(2, '0') + 's';
    };
    const id = setInterval(tick, 1000);
    tick();
  });
})();
